// components/PassPurchaseModal.js
import React from 'react';
import { FiX, FiShoppingCart, FiInfo } from 'react-icons/fi';
import '../styles/Modals.scss';

const PassPurchaseModal = ({ passes, eventTitle, onClose, onPurchase }) => {
  const getLowestPrice = () => {
    const prices = passes.map(p => parseFloat(p.price)).filter(p => p > 0);
    return prices.length > 0 ? Math.min(...prices) : 0;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content pass-modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <FiX />
        </button>

        <div className="modal-icon ticket">
          <FiShoppingCart size={48} />
        </div>

        <h2>Purchase Required</h2>
        <p className="modal-subtitle">
          This is a paid event. You need to purchase a pass to confirm your attendance.
        </p>

        <div className="passes-section">
          <h3>Available Passes</h3>
          {passes.map((pass, index) => (
            <div key={pass.id || index} className="pass-item">
              <div className="pass-info">
                <h4>{pass.name || 'General'}</h4>
                {pass.description && <p>{pass.description}</p>}
              </div>
              <div className="pass-price">
                <span className="price-label">From</span>
                <span className="price-amount">₹{pass.price}</span>
              </div>
            </div>
          ))}

          <div className="info-box">
            <FiInfo />
            <p>Platform fee (4% + GST) and payment gateway charges apply</p>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>
            Maybe Later
          </button>
          <button className="btn btn-primary" onClick={onPurchase}>
            <FiShoppingCart /> Buy Passes
          </button>
        </div>
      </div>
    </div>
  );
};

export default PassPurchaseModal;